import { focusInput } from "../../shared/utils";
import AbstractShapeMode from "./AbstractShapeMode";
import Coordinate from "../support/Coordinate";
import Line from "../shapes/Line";
import { DRAW } from "../../tools/actions/ActionHelper";

export default class LineMode extends AbstractShapeMode {
    coordinates = [];
    currentInput;

    display(g) {
        if (this.coordinates.length == 1) {
            this.coordinates[0].display(g);
        }
        if (this.coordinates.length > 0) {
            this.drawMenu.appearance.apply(g);
            g.stroke(0);
            g.strokeWeight(1);
            g.strokeJoin(g.ROUND);
            g.strokeCap(g.SQUARE);
            g.noFill();
            g.beginShape();
            this.coordinates.map((c) => g.vertex(c.currentX, c.currentY));
            let newCoordinate = this.newCoordinate;
            g.vertex(newCoordinate.currentX, newCoordinate.currentY);
            g.endShape();
        }
    }

    activate() {
        this.input.setDrawMode('line');
        this.drawMenu.disableFill();
    }

    pressMouseOnCanvas() {
        let lastCoordinate = this.coordinates[this.coordinates.length - 1];
        if (lastCoordinate && lastCoordinate.hovered()) {
            return;
        }
        this.currentInput = this.input.multiInput.getInput(this.coordinates.length);
        this.currentInput.show();
        this.coordinates.push(this.newCoordinate);
        this.resetSticky();
    }

    makeShape() {
        if (this.coordinates.length < 2) {
            return;
        }
        let line = new Line(
            this.provider,
            {
                coordinates: this.coordinates.map((c) => [c.absX, c.absY]),
            },
            this.drawMenu.appearance.clone(),
            this.speciesIds,
            this.labels
        );
        this.actions.execute(DRAW, line);
        this.reset();
    }

    mouseMoved() {
        if (this.currentInput) {
            this.currentInput.value(
                this.coordinates[this.coordinates.length - 1].distanceTo(this.view.snappedCoordinate)
            );
        }
    }

    doubleClickedOnCanvas() {
        this.makeShape();
        return true;
    }

    reset() {
        super.reset();
        this.coordinates = [];
        this.currentInput = null;
    }

    getTips() {
        if (this.touch) {
            if (this.coordinates.length == 0) {
                return 'Tap to place the first point of the line.';
            }
            return 'Tap to add points. Double-tap to finish.';
        }
        if (this.coordinates.length == 0) {
            return 'Click to place the first point of the line.';
        }
        return 'Click to place the next point. Double click or press enter to finish. Press 0-9 to focus input.';
    }

    get newCoordinate() {
        if (this.sticky['segment']) {
            let length = this.sticky['segment'].value();
            let lastCoordinate = this.coordinates[this.coordinates.length - 1];
            let angle = lastCoordinate.angleTo(this.view.snappedCoordinate);
            let x = lastCoordinate.absX + length * this.p.cos(angle);
            let y = lastCoordinate.absY + length * this.p.sin(angle);
            return new Coordinate(this.provider, x, y);
        }
        return this.view.snappedCoordinate;
    }

    pressKey(code) {
        switch (code) {
            case 49: // 1
                focusInput(this.getInput(0));
                return;
            case 50: // 2
                focusInput(this.getInput(1));
                return;
            case 51: // 3
                focusInput(this.getInput(2));
                return;
            case 52: // 4
                focusInput(this.getInput(3));
                return;
            case 53: // 5
                focusInput(this.getInput(4));
                return;
            case 54: // 6
                focusInput(this.getInput(5));
                return;
            case 55: // 7
                focusInput(this.getInput(6));
                return;
            case 56: // 8
                focusInput(this.getInput(7));
                return;
            case 57: // 9
                focusInput(this.getInput(8));
                return;
        }
    }
}
